import { Container, Col, Row } from "react-bootstrap";
import Footer from "../../components/Layout/Footer/Footer";
import "../../components/Layout/Jumbotron/JumbotronII";
import "../../components/Buttons/button.css";
import Card from "react-bootstrap/Card";
import ArticleOneImage from "../../images/tony-cosentino.png";

const News = () => {
  return (
    <div>
      <Container className="JumboBGII" fluid>
        <div className="OverlayII">
          <Row>
            <Col className="text-center">
              <h1>NEWS</h1>
            </Col>
          </Row>
        </div>
      </Container>
      <Container className="my-5">
        <h2 className="text-start my-5">2022</h2>
        <Card style={{ width: "18rem" }}>
          <Card.Img variant="top" src={ArticleOneImage} />
          <Card.Body className="text-start">
            <Card.Title>Fast Track: Ontario grad climbing NASCAR </Card.Title>
            <Card.Text>
              <p className="text-dark">
                Tony Cosentino got bit by the racing bug when he was young and
                the 2006 Ontario graduate has been chasing his dream ever since.
              </p>
            </Card.Text>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.richlandsource.com/open_source/fast-track-ontario-grad-climbing-nascar-ladder/article_44a2296e-b6a0-11ec-98a6-4b0ed875d8ec.html?utm_medium=social&utm_source=facebook&utm_campaign=user-share&fbclid=IwAR0CzsKr7v8Y-RDZmrobLsiovs9Na65r8Z2kvGENW7QjOv7hBLu57IQbBUo"
            >
              <button className="btn2">Learn More</button>
            </a>
          </Card.Body>
        </Card>
      </Container>
      <Footer />
    </div>
  );
};

export default News;
